module.exports = __webpack_public_path__ + "static/media/user-icon.b499afee.svg";